<template>
  <div class="overflow-x-auto">
    <table class="table" v-if="campaigns.length">
      <thead>
        <tr>
          <th>#</th>
          <th>{{ __("Name") }}</th>
          <th>{{ __("Type") }}</th>
          <th>{{ __("Status") }}</th>
          <th>{{ __("User") }}</th>
          <th>{{ __("Start date") }}</th>
          <th>{{ __("End date") }}</th>
          <th>{{ __("Created At") }}</th>
          <th>{{ __("Action") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in campaigns">
           <td>{{ meta.per_page * (meta.current_page - 1) + index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.type }}</td>
          <td>{{ __(item.status.capitalize()) }}</td>
          <td>{{ item.user }}</td>
          <td>{{ item.start_date }}</td>
          <td>{{ item.end_date }}</td>
          <td>{{ item.created_at }}</td>
          <td>
            <router-link
              :to="{ name: 'user.campaign.show', params: { id: item.id } }"
              :class="{
                'btn-disabled':
                  !can('campaign.view.all') &&
                  !can('campaign.view.self', item.self),
              }"
              class="btn btn-outline btn-primary btn-sm ml-2"
            >
              {{ __("Show") }}
            </router-link>
            <router-link
              :to="{ name: 'user.campaign.edit', params: { id: item.id } }"
              :class="{
                'btn-disabled':
                  !can('campaign.edit.all') &&
                  !can('campaign.edit.self', item.self),
              }"
              class="btn btn-outline btn-info btn-sm ml-2"
            >
              {{ __("Edit") }}
            </router-link>
            <label
              @click="setItem(item)"
              for="delete-modal"
              :class="{
                'btn-disabled':
                  !can('campaign.delete.all') &&
                  !can('campaign.delete.self', item.self),
              }"
              class="btn btn-outline btn-error btn-sm"
            >
              {{ __("Delete") }}
            </label>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="col-span-12 flex flex-col items-center mt-9" v-else>
      <NotFound />
    </div>
  </div>
</template>
<script setup>
const {
  meta,
} = useDashboard();
defineProps(["campaigns"]);
const emit = defineEmits(["setItem"]);
const setItem = (item) => emit("setItem", item);
</script>
